
import { Check } from './check.class';
import { CheckElec } from './check-elec.class';
import { CheckMeca } from './check-meca.class';
import { CheckDesurging } from './check-desurging.class';
import { CheckAgitator } from './check-agitator.class';

export function checkFactory(obj): Check {
  switch(obj.type) {
    case CheckElec.type:
      return new CheckElec(obj);
    case CheckMeca.type:
      return new CheckMeca(obj);
    case CheckDesurging.type:
      return new CheckDesurging(obj);
    case CheckDesurging.type:
      return new CheckDesurging(obj);
    case CheckAgitator.type:
      return new CheckAgitator(obj);
    default:
      return null;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/check/check.factory.ts